export * from "./forget-password";
import ForgetPassword from "./forget-password";
export default ForgetPassword;
